<template>
  <div class="producto-envasado-lista  mt-4">

    <!-- Título -->
    <h3 class="mb-2 text-envasado">
      <font-awesome-icon icon="boxes" class="me-2" />
      Productos Finales Envasados
    </h3>

    <!-- Indicador de vista actual -->
    <div class="mb-4">
      <span class="badge fs-6 px-3 py-2 rounded-pill"
        :class="sinStock ? 'bg-danger-subtle text-danger fw-bold' : 'bg-success-subtle text-success fw-bold'">
        {{ sinStock ? 'SIN Stock' : 'Con Stock Disponible' }}
      </span>
    </div>

    <!-- Filtro -->
    <div class="bg-envasado-light p-3 rounded shadow-sm mb-4 d-flex align-items-center gap-3 filtros-busqueda">
      <font-awesome-icon icon="search" class="text-muted" />
      <input v-model="buscar" type="text" class="form-control"
        placeholder="Buscar por código, tipo de producto o envase..." />
    </div>

    <!-- Estadísticas -->
    <EstadisticasProductoEnvasado :envasados="envasados" />

    <!-- Listado -->
    <div v-if="envasadosFiltrados.length" class="row g-3">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="envasado in paginados" :key="envasado.id">
        <ProductoFinalEnvasadoCard :envasado="envasado" @editar="editar" @ajustar="ajustar" @anulado="fetchEnvasados"
          @precioActualizado="fetchEnvasados" />
      </div>
    </div>

    <p v-else-if="!loading" class="text-muted">No hay productos envasados que coincidan.</p>

    <!-- Cargando -->
    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-envasado" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <!-- Paginado -->
    <nav v-if="totalPaginas > 1" class="mt-4">
      <ul class="pagination justify-content-center small">
        <li class="page-item" :class="{ disabled: pagina === 1 }">
          <button class="page-link" @click="pagina--">Anterior</button>
        </li>
        <li v-for="page in totalPaginas" :key="page" class="page-item" :class="{ active: pagina === page }">
          <button class="page-link" @click="pagina = page">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: pagina === totalPaginas }">
          <button class="page-link" @click="pagina++">Siguiente</button>
        </li>
      </ul>
    </nav>

  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ProductoFinalEnvasadoCard from './ProductoFinalEnvasadoCard.vue';
import EstadisticasProductoEnvasado from './EstadisticasProductoEnvasado.vue';
import axios from '@/axios';

export default {
  name: "ProductoFinalEnvasadoLista",
  components: {
    FontAwesomeIcon,
    ProductoFinalEnvasadoCard,
    EstadisticasProductoEnvasado
  },
  watch: {
    sinStock() {
      this.fetchEnvasados();
    }
  },
  props: {
    sinStock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      envasados: [],
      buscar: "",
      loading: false,
      pagina: 1,
      porPagina: 6,
      club_id: this.$store.getters.getClubActual.id
    };
  },
  computed: {
    envasadosFiltrados() {
      return this.envasados.filter(e =>
        (e.codigo && e.codigo.toLowerCase().includes(this.buscar.toLowerCase())) ||
        (e.tipo_producto && e.tipo_producto.toLowerCase().includes(this.buscar.toLowerCase())) ||
        (e.tipo_envase && e.tipo_envase.toLowerCase().includes(this.buscar.toLowerCase()))
      );
    },
    totalPaginas() {
      return Math.ceil(this.envasadosFiltrados.length / this.porPagina) || 1;
    },
    paginados() {
      const inicio = (this.pagina - 1) * this.porPagina;
      return this.envasadosFiltrados.slice(inicio, inicio + this.porPagina);
    }
  },
  methods: {
    async fetchEnvasados() {
      this.loading = true;
      try {
        const url = this.sinStock
          ? '/api/producto_final_envasado_sin_stock'
          : '/api/producto_final_envasado_con_stock';

        const res = await axios.get(url, {
          params: { club_id: this.club_id }
        });

        this.envasados = res.data;
        this.pagina = 1;

      } catch (error) {
        console.error("Error al obtener productos envasados", error);
        alert("Error al cargar los productos envasados.");
      } finally {
        this.loading = false;
      }
    },
    editar(envasado) {
      this.$emit('viewChange', { view: 'editar', productoFinalEnvasado: envasado });
    },
    ajustar(envasado) {
      this.$emit('viewChange', { view: 'ajustar', productoFinalEnvasado: envasado });
    }
  },
  mounted() {
    this.fetchEnvasados();
  }
};
</script>

<style scoped>
.text-envasado {
  color: #5a5a89;
}

.bg-envasado-light {
  background-color: #f4f4f8;
}

.pagination .page-link {
  color: #5a5a89;
}

.pagination .page-item.active .page-link {
  background-color: #5a5a89;
  color: white;
}

.bg-danger-subtle {
  background-color: #fdecea;
}

.bg-success-subtle {
  background-color: #e6f4ea;
}
</style>
